import EStyleSheet from "react-native-extended-stylesheet";

export const styles = EStyleSheet.create({
  container: {
    flex: 0.7,
    alignItems: "center",
    justifyContent: "center",
    flexDirection: "row",
    flexWrap: "wrap",
  },
  statBox: {
    width: "24vw",
    height: "14vh",
    margin: "0.9vmax",
    paddingHorizontal: "2vw",
    paddingVertical: "2vh",
    backgroundColor: "$question_text",
  },
  text: {
    color: "$survey_card",
    paddingTop: "1vmin",
    fontSize: "1.6vmax",
  },
  heading: {
    fontSize: "1.2vmax",
    fontWeight: "bold",
    textTransform: "uppercase",
  },
});
